import { LoadingStateType } from '@/shared/config';

import { getBillingProductBlockReason } from '@/entities/organization';

import { AddSubscriptionBlockReason } from '../config';

type GetAddSubscriptionBlockReasonParams = {
  accountLoadingState: LoadingStateType;
  canEditProducts: boolean;
  hasScheduledSubscription: boolean;
  isCurrentSubscriptionAutoRenewing: boolean;
};

// Returns why "Add subscription" is unavailable, or undefined when it is fine.
//
// First match wins, so the admin is told about the thing they would hit first.
export const getAddSubscriptionBlockReason = (
  params: GetAddSubscriptionBlockReasonParams,
): AddSubscriptionBlockReason | undefined => {
  const {
    accountLoadingState,
    canEditProducts,
    hasScheduledSubscription,
    isCurrentSubscriptionAutoRenewing,
  } = params;

  // antd renders a Card's header while its body is still a skeleton, so without
  // this the link is clickable before an account ID exists.
  if (accountLoadingState !== 'succeeded') {
    return 'accountLoading';
  }

  const productBlockReason = getBillingProductBlockReason({
    canEditProducts,
  });

  if (productBlockReason) {
    return productBlockReason;
  }

  if (hasScheduledSubscription) {
    return 'scheduledExists';
  }

  // An auto-renewing subscription creates its own successor, which would collide
  // with a scheduled one. Billing refuses it, so the button says so up front.
  if (isCurrentSubscriptionAutoRenewing) {
    return 'autoRenewal';
  }

  return undefined;
};
